<evc-modal [showBackdrop]="true" [showCloseButton]="true" [showReduceButton]="false" [width]="'600px'" [height]="'550px'" (closeModal)="onClose()">
  <ng-container modal-title>{{ "inspectionForm.title" | translate }}</ng-container>

  <ng-container modal-content>
    <form [formGroup]="form">
      <div class="form-field">
        <label for="title">{{ "inspectionForm.titleLabel" | translate }}</label>
        <input
          pInputText
          id="title"
          name="title"
          [required]="true"
          [placeholder]="'inspectionForm.titlePlaceholder' | translate"
          formControlName="title"
        />
        @for (errorKey of form.controls.title.errors | keyvalue; track errorKey.key) {
          @if (titleErrorTranslationKeys[errorKey.key]) {
            <small class="form-error">{{ titleErrorTranslationKeys[errorKey.key] | translate }}</small>
          }
        }
      </div>
      <div class="form-field">
        <div class="form-field-label-row">
          <label for="liveAsset">{{ "inspectionForm.liveAssetLabel" | translate }}</label>
          @if (formService.rootOnlyToggleEnabled()) {
            <div class="roots-only-toggle">
              <input
                type="checkbox"
                id="rootsOnly"
                [checked]="formService.rootsOnly()"
                (change)="formService.rootsOnly.set($any($event.target).checked)"
              />
              <label for="rootsOnly">{{ "inspectionForm.rootsOnly" | translate }}</label>
            </div>
          }
        </div>
        <div class="live-asset-select-row">
          <p-select
            id="liveAsset"
            appendTo="body"
            formControlName="liveAsset"
            [options]="formService.liveAssetsOptions()"
            optionLabel="displayLabel"
            optionValue="id"
            filter="true"
            filterBy="name,description,displayName,shortName,serialNo"
            [placeholder]="'inspectionForm.liveAssetPlaceholder' | translate"
            [virtualScroll]="formService.liveAssetsOptions().length > 20"
            [virtualScrollItemSize]="20"
          />
          @if (canCreateLiveAsset) {
            <evc-button
              buttonStyle="accent"
              importance="secondary"
              size="small"
              [textContent]="'inspectionForm.createLiveAsset' | translate"
              (click)="goToCreateLiveAsset()"
            ></evc-button>
          }
        </div>
      </div>
      <div class="form-field">
        <label>{{ "inspectionForm.inspectionDateLabel" | translate }}</label>
        <p-date-picker
          appendTo="body"
          [placeholder]="'inspectionForm.inspectionDatePlaceholder' | translate"
          [showButtonBar]="true"
          [dateFormat]="'yy-mm-dd'"
          id="inspectionDate"
          formControlName="inspectionDate"
        />
      </div>
      @if (!isOnPremise) {
        <div class="form-field">
          <label for="inspectors">{{ "inspectionForm.inspectorsLabel" | translate }}</label>
          <p-multiselect
            id="inspectors"
            appendTo="body"
            ariaLabel="inspectors"
            name="inspectors"
            formControlName="inspectors"
            [options]="formService.inspectors()"
            optionLabel="fullName"
            optionValue="id"
            showToggleAll="false"
            [placeholder]="'inspectionForm.inspectorsPlaceholder' | translate"
          />
        </div>
      }
    </form>
  </ng-container>

  <div modal-actions class="actions-button">
    <evc-button buttonStyle="accent" importance="secondary" [textContent]="'inspectionForm.cancel' | translate" (click)="onClose()"></evc-button>
    <evc-button
      buttonStyle="accent"
      importance="primary"
      [textContent]="'inspectionForm.save' | translate"
      (click)="save()"
      [disabled]="form.invalid || this.form.disabled"
    ></evc-button>
  </div>
</evc-modal>
